import { useContext } from 'react';
import styled from 'styled-components';
import { useViewport } from '@/lib/layout/dimensions';
import { AccountInfoContext } from '../account/account-info';
import bgImg from '../../../../assets/images/static_pages/tcr_banner_bg.svg';
import dotImage from '../../../../assets/images/static_pages/tcr_banner_dots.svg';
import { X } from 'react-feather';
import { useNavigationActions } from '@/lib/navigation';
import { orgPlanSelector } from '../../../redux/app/selectors/organization';
import { useSelector } from 'react-redux';

interface ReminderHeaderProps {
  handleDisableBanner?: any;
}

export const ReminderHeader = ({
  handleDisableBanner,
}: ReminderHeaderProps) => {
  const isMobile = useViewport((width) => width < 600, 500);
  const { subdomain, isTollFreeNumber, isAvoVerified, isTcrCampaign } = useContext(AccountInfoContext);
  const isShowA2P = !isTollFreeNumber && (!isAvoVerified || !isTcrCampaign);
  const { navigate } = useNavigationActions();
  const learnMoreLink = isTollFreeNumber ? 'https://help.avochato.com/administrative/gKg5a8E76p4DLgaVdhAhDM/toll-free-number-verification/hyUfwemXBVddaxPTRd8Sg7' : 'https://help.avochato.com/verify-your-business-with-a2p/register-for-a2p';
  const greeting = isTollFreeNumber ? 'Verify your Toll-Free Number' : 'A2P Registration Reminder';
  const description = isTollFreeNumber
    ? 'All inboxes sending SMS and MMS messages from a Toll-Free Number require completing the Toll-Free Verification Process.'
    : 'All inboxes sending SMS and MMS messages to U.S. phone numbers must have a registered Brand and Use Case.';

  const handleLearnMore = () => {
    window.open(learnMoreLink, '_blank','noopener');
  };

  const handleRegisterTfn = () => {
    navigate({path: `/accounts/${subdomain}/numbers`, params: {} });
  };

  const plan = useSelector(orgPlanSelector);
  const isTrial = plan === 'trial-plan-4';
  const tcrPath = isTrial ? 'tcr/first_submission' : 'tcr/register_brand';

  const handleRegisterTcr = () => navigate({
    path: `/accounts/${subdomain}/${tcrPath}`,
    params: {},
  });

  return (
    <BannerWrapper>
      <DotImage src={dotImage} alt="Avochato" />
      <Background src={bgImg} alt="Avochato" />
      <TextWrap>
        <Greeting>{greeting}</Greeting>
        <Description>{description}</Description>
      </TextWrap>
      <ButtonWrap>
        <RegisterButton
          type="button"
          onClick={isTollFreeNumber ? handleRegisterTfn : handleRegisterTcr}
        >
          Register Now
        </RegisterButton>
        <LearnMoreButton
          type="button"
          onClick={handleLearnMore}
        >
          Learn More
        </LearnMoreButton>
        <XWrapper>
        <X
          onClick={handleDisableBanner}
          style={{ cursor: 'pointer', marginLeft: '10px', height: '20px',  width: '20px' }}
          width="15px"
          height="15px"
        />
        </XWrapper>
      </ButtonWrap>
    </BannerWrapper>  
  );
};

const BannerWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #F5F3C8;
  height: 84px;
  width: 100%;
  position: relative;
  overflow: hidden;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
`;

const DotImage = styled.img`
  position: absolute;
  z-index: 1;
`;

const Background = styled.img`
  position: absolute;
  z-index: 0;
`;

const TextWrap = styled.text`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-left: 120px;
`;

const Greeting = styled.p`
  font-size: 18px;
  font-weight: 800 !important;
  margin: 0 0 5px 0;
`;

const Description = styled.p`
  font-size: 12px;
  max-width: 650px;
  margin: 0;
`;
const ButtonWrap = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 20px;
`;

const XWrapper = styled.div`
  min-width: 20px;
`;

const RegisterButton = styled.button`
  border: 1px solid #DD7019;
  font-family: Montserrat, sans-serif !important;
  cursor: pointer;
  padding: 8px 25px;
  font-size: 12px;
  text-align: center;
  background: #DD7019;
  color: white !important;
  border-radius: 30px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 10px
`;

const LearnMoreButton = styled.button`
  border: 1px solid #DD7019;
  font-family: Montserrat, sans-serif !important;
  cursor: pointer;
  padding: 8px 25px;
  font-size: 12px;
  text-align: center;
  color: white !important;
  border-radius: 30px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: none;
  color:#DD7019 !important;
  border-radius: 30px;
`;
